export default __webpack_public_path__ + "static/media/mb-cta-analytics.f6ddf32c.svg";